import wixWindow from 'wix-window';
import { to } from 'wix-location';
import { currentUser } from 'wix-users';

$w.onReady(function () {
    // if (currentUser.loggedIn) {
    //     console.log('currentUser.loggedIn');
    //     to('/home')
    // }
});